/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Next_PaymentInputs */

const en_plan_next_payment = /** @type {(inputs: Plan_Next_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next payment`)
};

const es_plan_next_payment = /** @type {(inputs: Plan_Next_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo pago`)
};

/**
* | output |
* | --- |
* | "Next payment" |
*
* @param {Plan_Next_PaymentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_next_payment = /** @type {((inputs?: Plan_Next_PaymentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Next_PaymentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_next_payment(inputs)
	return en_plan_next_payment(inputs)
});